module.exports = __webpack_public_path__ + "static/BP_N008041.ea5d3d29.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/BP_N008041.jpg
// module id = 884
// module chunks = 273949829873662